import { useTheme } from '@daily/shared/contexts/Theme';
import { throttle } from '@daily/shared/lib/throttle';
import {
  useAudioLevel,
  useAudioTrack,
  useLocalSessionId,
} from '@daily-co/daily-react';
import { useRef } from 'react';

export const MicVolume = () => {
  const { colors } = useTheme();
  const localSessionId = useLocalSessionId();
  const audioTrack = useAudioTrack(localSessionId);

  useAudioLevel(
    audioTrack.persistentTrack,
    throttle((volume: number) => {
      // If this component unmounts while a throttling cycle is in place,
      // the next time the throttled function runs the dots are not available anymore.
      // So let's make sure they exist before assigning `height`s.
      if (!dot1.current || !dot2.current || !dot3.current) return;

      const getHeight = (base: number) =>
        `${
          Math.round(100 * (3 + base * 2 * (volume >= 0.1 ? volume : 0))) / 100
        }px`;

      dot1.current.style.height = getHeight(5);
      dot2.current.style.height = getHeight(11);
      dot3.current.style.height = getHeight(7);
    }, 150)
  );

  const dot1 = useRef<HTMLSpanElement>(null);
  const dot2 = useRef<HTMLSpanElement>(null);
  const dot3 = useRef<HTMLSpanElement>(null);

  return (
    <div>
      <span className="dot" ref={dot1} />
      <span className="dot" ref={dot2} />
      <span className="dot" ref={dot3} />
      <style jsx>{`
        div {
          align-items: center;
          display: flex;
          height: 16px;
          justify-content: center;
          width: 16px;
        }
        div :global(.dot) {
          background: ${colors.accent};
          border-radius: 3px;
          height: 3px;
          margin: 0 1px;
          transition: height 0.15s ease;
          width: 3px;
        }
      `}</style>
    </div>
  );
};
MicVolume.displayName = 'MicVolume';
